import React from "react";
import Main from "../components/layout/Main";
import {QueryBuilder} from "../components/query-builder/QueryBuilder";

export const QB_TITLE = 'Query Builder'
export const COHORT_ANALYSER_TITLE = 'Cohort Analyzer'


interface QueryBuilderPageProps {
    title?: string
}

export const QueryBuilderPage = ({title}: QueryBuilderPageProps) => {
    return <Main>
        <QueryBuilder/>
    </Main>
}